let isDataLoadingIconVisible = false;

const YBQ_ENV = {
    storeId: '69c85d1c75371e29d44af339',
    gsServer: 'https://aunzm.aoshangbao.com.au/pbtrv',


    setDataLoadingFlag: function(loading) {
        isDataLoadingIconVisible = loading;
    },

    getDataLoadingFlag: function() {
        return isDataLoadingIconVisible;
    },

    updateStoreTags: function(attrObj) {
        Object.keys(attrObj).forEach((_key) => {
            this[_key] = attrObj[_key];
        });
    }
};


export default YBQ_ENV;
